export default __webpack_public_path__ + "static/media/medisports.a75e42c9.png";